<template>
  <div class="list-container">
    <!--    List-->
    <div class="terms-container">
      <div class="legal-protocol">
        <div class="title">Permisos requeridos para utilizar Prestalight</div>
        <div class="desc">
          Para garantizar el correcto funcionamiento de nuestros servicios de
          préstamo y proteger tu seguridad, necesitamos acceder a ciertos
          permisos e información desde tu dispositivo:
        </div>
        <div class="desc" v-if="showPrivacy">
          Para más detalles sobre permisos y gestión de datos personales, consulta nuestra
          <span class="mark-text" @click="viewPrivacyAgreement()"
            >[Política de Privacidad]</span
          >
          .
        </div>

        <div v-if="!isIOS" class="desc-li">📍 Ubicación</div>

        <div v-if="!isIOS" class="desc">
          Recogemos tu ubicación aproximada para evaluar riesgos relacionados
          con tu cuenta y mejorar la seguridad de los datos. Todas las
          transacciones están protegidas con cifrado SSL de 128 bits. Los datos
          se envían por conexión segura y se almacenan en nuestros servidores:
          www.prestalight.com
        </div>

        <div class="desc-li">📷 Cámara</div>

        <div class="desc">
          Necesitamos acceso a la cámara para facilitar la verificación de
          identidad (KYC). Esto te permitirá tomar fotos de tu DNI y rostro
          directamente desde la app. No accederemos ni almacenaremos otras fotos
          o vídeos de tu dispositivo. Sin tu consentimiento, no podremos
          completar el proceso de verificación.
        </div>

        <div v-if="!isIOS" class="desc-li">✉️ Mensajes de texto</div>

        <div v-if="!isIOS" class="desc">
          Con tu permiso, accedemos únicamente a tus mensajes financieros
          (remitente, fecha y contenido). Usamos esta información para evaluar
          tu situación financiera, determinar si puedes obtener un préstamo y
          prevenir fraudes. Los mensajes se transmiten y almacenan a través de
          nuestros servidores seguros (https://www.prestalight.com/). Cumplimos
          con la normativa vigente y nuestras políticas de privacidad para
          proteger tus datos. No accedemos a mensajes no relacionados ni
          compartimos tus datos con terceros. Puedes activar o desactivar este
          permiso en cualquier momento desde la configuración.
        </div>

        <div class="desc-li">🔔 Notificaciones</div>

        <div class="desc">
          Con tu permiso, te enviaremos recordatorios, actualizaciones
          importantes y comunicaciones personalizadas. Puedes activar o
          desactivar esta opción cuando quieras desde la configuración. Si
          decides no autorizarlo, podrás seguir usando la app normalmente.
        </div>

        <div v-if="!isIOS" class="desc-li">📱 Aplicaciones instaladas</div>

        <div v-if="!isIOS" class="desc">
          Recopilamos únicamente información básica de ciertas apps instaladas
          (nombre, versión, fecha de instalación/actualización, si son del
          sistema), con el fin de prevenir fraudes y proteger la seguridad
          financiera de tu cuenta.
        </div>

        <div class="space-400"></div>
        <div class="subtitle">Permisos estándar del sistema</div>
        <div class="space-400"></div>

        <div class="desc-li">📶 Estado del WiFi</div>

        <div class="desc">
          Usamos esta información para evaluar riesgos y detectar posibles
          anomalías en la red.
        </div>

        <div class="desc-li">🌐 Estado de red</div>

        <div class="desc">
          Nos permite conocer el tipo de conexión y estado de red para evitar
          pérdida de datos o retrasos causados por problemas de conectividad.
        </div>

        <div v-if="!isIOS" class="desc-li">📊 Identificador publicitario (ADID)</div>

        <div v-if="!isIOS" class="desc">
          Recolectamos tu ID publicitario de Google (GAID) para analizar
          resultados de campañas y mejorar tu experiencia publicitaria. Puedes
          desactivar esta opción desde la configuración de tu dispositivo.
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, inject, markRaw, onMounted, ref, watch } from 'vue';
import router from '@/router';
import { useRoute } from 'vue-router';
import { channelMethods, postToApp } from '@/utils/channelMethod';
import { formatDateTime } from '@/utils';

export default {
  name: 'permissionPage',
  methods: { formatDateTime },
  props: {
    type: String
  },
  setup(props: any) {
    const loading = ref(false);
    const route = useRoute();

    const dialogMode = computed(() => {
      return route.query.dialogMode;
    });

    const viewPrivacyAgreement = () => {
      if (isIOS.value) {
        router.push({
          path: '/privacy_policy/ios',
          query: { 'source': 'permission' },
        });
      } else {
        router.push({
          path: '/privacy',
          query: { 'source': 'permission' },
        });
      }

    };

    const showPrivacy = computed(() => {
      return route.query.showPrivacy == 'true' || isIOS.value;
    });

    const handleBackClick = () => {
      postToApp(channelMethods.goBack);
    };

    const isIOS = computed(() => {
      return props.type === 'ios';
    })

    onMounted(() => {
      document.title = 'Permissions Disclosure Agreement';
      // postToApp(channelMethods.darkMode, 'default');
    });


    return {
      loading,
      dialogMode,
      showPrivacy,
      isIOS,
      viewPrivacyAgreement,
      handleBackClick
    };
  }
};
</script>

<style lang="scss" scoped>
.white-bg {
  background: #ffffff;
}

.list-container {
  width: 100vw;
  height: 100vh;
  max-width: $max-width;
  position: relative;

  display: flex;
  flex-direction: column;

  .bar-masking {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;

    height: 179px;
    background-color: white;
  }
}
</style>
